import 'Plugins/autocompletePlugin';
import { getLanguages } from 'Components/languageFilter';
import { showHideProjects } from 'Utils/filters';

// accordion menu init
export default function initAutocomplete() {
	jQuery('.input-holder').each(function() {
		const holder = jQuery(this);
		const input = holder.find('input.autocomplete');
		const btnHolder = holder.find('.selected-holder');

		input.on('autocompleteselect', (event, ui) => {
			const { label, value } = ui.item;
			const link = btnHolder.find(`[data-value="${ value }"]`);

			setTimeout(() => {
				input.val('');
			}, 100);

			if (link.length) return;

			const tag = jQuery(`<a href="#" data-value="${ value }" class="selected-lang">${ label } <span class="delete-btn">x</span></a>`);
			tag.appendTo(btnHolder);
      showHideProjects();
		});

    const source = Array.from(getLanguages());

		input.uiAutocomplete({
			source,
			appendTo: '#autocomplete-id'
		});

		jQuery(document).on('click', '.selected-lang', (e) => {
			e.preventDefault();
			jQuery(e.target).remove();
      showHideProjects();
		});
	});
}
